import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { AssetsLiveOccupancyState } from "controllers/AssetsLiveOccupancyController/state";

export const initialState: AssetsLiveOccupancyState = {
  lastOccupancyEstimates: PendingData(O.none),
  lastOccupancyTimestamp: PendingData(O.none),
};
